const If = (props) => {
    return (
        <>
            {props.if && props.children}
        </>
    )
}

export default If;